import Head from 'next/head'
import Image from 'next/image'
import Nav from '@/components/Nav';
import Footer from '@/components/Footer';
import FeaturedPosts from '@/components/posts/FeaturedPosts';
import groq from 'groq';
import client from '../sanity_client';
import {urlFor} from '../sanity_image';
import {toHTML} from '@portabletext/to-html';
import React, { useState } from "react";
import Banner from '@/components/PageBanner';
import ContactForm from '@/components/ContactForm';

export default function Blog({pageContent, posts, featuredPosts, siteSettings}:any) {
  // const postsPerPage = 10;
  // const [postArrStart, setPostArrStart] = useState(0);
  // const [postArrEnd, setPostArrEnd] = useState(postsPerPage);
  // const [hideOlderPostBtn, setHideOlderPostBtn] = useState(true);
  // const [hideNewerPostBtn, setHideNewerPostBtn] = useState(false);
  // const currentViewPosts = posts.slice(postArrStart, postArrEnd);

  // function paginatePosts(event:any) {
  //   const dir = event.target.getAttribute('data-direction');
  //   let operator;
  //   if(dir == 'up') {
  //     operator = "+";
  //   } else {
  //     operator = "-";
  //   }
  //   setPostArrStart(eval(`${postArrStart} ${operator} ${postsPerPage}`));
  //   setPostArrEnd(eval(`${postArrEnd} ${operator} ${postsPerPage}`));
  //   // eval is used here to avoid having two blocks of basically the same code, one for addition and one for subtraction
  //   if(eval(`${postArrEnd} ${operator} ${postsPerPage}`) >= posts.length && eval(`${postArrStart} ${operator} ${postsPerPage}`) > 0) {
  //     setHideOlderPostBtn(true); // hide right side pagination button
  //     setHideNewerPostBtn(false); // show left side pagination button
  //   } else if (eval(`${postArrEnd} ${operator} ${postsPerPage}`) <= posts.length && eval(`${postArrStart} ${operator} ${postsPerPage}`) > 0) {
  //     setHideOlderPostBtn(false); // show right side pagination button
  //     setHideNewerPostBtn(false); // show left side pagination button
  //   } else if(eval(`${postArrEnd} ${operator} ${postsPerPage}`) <= posts.length && eval(`${postArrStart} ${operator} ${postsPerPage}`) == 0) {
  //     setHideOlderPostBtn(false); // show right side pagination button
  //     setHideNewerPostBtn(true); // hide left side pagination button
  //   }
  // }

  return (
    <>
    <Head>
      <title>The Line of Sight &#8480;</title>
    </Head>
    <Nav />
    <main className="row blog-posts-container">
      <Banner bannerHeading={pageContent[0].banner_heading} bannerSubHeading={pageContent[0].banner_sub_heading} bannerImage={urlFor(pageContent[0].banner_image).width(1920).url()} />
      <div className="col-12">
        <div className="container">
          <div className="row rp-overview-row">
            <div className="col-12 rp-overview-col">
              <div className="overview-text regular-font" dangerouslySetInnerHTML={{__html: toHTML(pageContent[0].overview_text)}}>
                {/* */}
              </div>
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-9 blog-post-col">
              <div className="row">
                {posts.map((post:any) => (
                  <>
                    <div className="col-12 blog-post">
                      <h4 className="title title-font">{post.title}</h4>
                      <div className="details regular-font">
                        {post.category != '' ? 
                            <><span className="category">{post.category}</span> <i className="fa fa-circle"></i></>
                          :
                            ''
                        }
                        {post.date} <i className="fa fa-circle"></i> 
                        {post.author}
                      </div>
                      {post.post_image != '' ?
                          <div className="col-12 post-image-container">
                            <img className="post-image" src={urlFor(post?.post_image).width(1200).url()} />
                          </div>
                        :
                          ''
                      }
                      <div className="summary regular-font" dangerouslySetInnerHTML={{__html: toHTML(post.summary)}}>
                        {/* */}
                      </div>
                      <div className="read-more regular-font">
                        <a href={`/post/${post.url_path}`}>Read More</a>
                      </div>
                    </div>
                    <div>
                      <img className="blog-divider-img" src="/img/blog-divider.png" />
                    </div>
                  </>
                ))}
              </div>
{/*              <div className={`w-full flex items-center ${hideNewerPostBtn ? 'justify-end' : 'justify-between'}`}>
                {hideNewerPostBtn ?
                  ''
                  :
                  <button className="purpleBtn" onClick={paginatePosts} data-direction="down">Newer Posts</button>
                }
                {!hideOlderPostBtn && postsPerPage < posts.length ?
                  <button className="purpleBtn" onClick={paginatePosts} data-direction="up">Older Posts</button>
                  :
                  ''
                }
              </div>*/}
            </div>
            <FeaturedPosts featuredPosts={featuredPosts} />
          </div>
        </div>
      </div>
      <ContactForm adminEmails={siteSettings[0].admin_emails} />
    </main>
    <Footer />
    </>
  )
}

export async function getServerSideProps() {
  const pageContent = await client.fetch(groq`*[_type == "blogPage"]`);
  const posts = await client.fetch(groq`*[_type == "post"] | order(date desc)`);
  const featuredPosts = await client.fetch(`*[_type == "post" && featured_post == true] | order(title asc)`);
  const siteSettings = await client.fetch(groq`*[_type == "siteSettings"]`);
  return {
    props: {
      pageContent: pageContent,
      posts: posts,
      featuredPosts: featuredPosts,
      siteSettings: siteSettings
    }
  }
}
